// @flow

import { type Theme, type ThemeId } from './types';

import defaultTheme from './default-theme';
import litbTheme from './litb-theme';
import mitbTheme from './mitb-theme';
import upliftTheme from './uplift-theme';
import newVoucher from './new-voucher-theme';

export function getThemeById(id: ?string|ThemeId): Theme {
  switch(id) {
    case 'mitb':
      return mitbTheme;
    case 'litb':
      return litbTheme;
    case 'uplift':
      return upliftTheme;
    case 'new-voucher':
      return newVoucher;
    default:
      return defaultTheme;
  }
}
